export const isPreviewMode = (): boolean => process.env.PREVIEW_MODE === '1';
